import ScrollToTop from "./ScrollToTop";

function isDict(v) {
    return typeof v==='object' && v!==null && !(v instanceof Array) && !(v instanceof Date);
}

export { ScrollToTop, isDict };